<template>
    <crud-create :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @create="create"
                 @close="$emit('close')"
    >
        <manual-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-create>
</template>

<script>

    import ManualProvider from "../../../../providers/ManualProvider";
    
    import {CrudCreate, ClientError} from '@dracul/common-frontend'
    
    import ManualForm from "../ManualForm";
    
    


    export default {
        name: "ManualCreate",
         
        components: { ManualForm, CrudCreate },
        
        props:{
          open: {type: Boolean, default: true}
        },
        
        data() {
            return {
                title: 'cobrox.manual.creating',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                form: {
                    nombre: '',
                    link: ''
                }
            }
        },
        
        methods: {
            create() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    ManualProvider.createManual(this.form).then(r => {
                            if (r) {
                                this.$emit('itemCreated',r.data.createManual)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }

        },
    }
</script>

<style scoped>

</style>

